import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson10: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson9"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[120%]">Crypto Wallets</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson11"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[9.5rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-[1.88rem] text-white font-dm-sans">

        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>What is a Cryptocurrency Wallet?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                A cryptocurrency wallet stores your public and private keys
                required to buy cryptocurrencies and holds proof of your digital
                cash by providing digital signatures authorizing each
                transaction. A crypto-wallet is a storage system, holding your
                digital currency and assets, such as Ethereum and your NFTs. You
                can then connect your wallet to websites and spend like normal
                transactions.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[89.75rem] h-[51.79rem] object-cover"
          alt=""
          src="/i44@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Common Misconceptions About Cryptocurrency Wallets:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Unlike traditional wallets, digital wallets do NOT store
                  currency (Explained Below)
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>These currencies do not exist in physical form</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  All records of transactions are stored on the Blockchain
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Crypto wallets interface with various blockchains</span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  In doing this it allows wallet users to monitor their balance,
                  send/receive money, etc
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">How Does It Work?</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  When someone sends you cryptocurrency they are signing off
                  ownership of the coins to your wallet address. To be able to
                  use those coins and unlock the funds, the private key stored
                  in your wallet must match the public address the currency is
                  assigned to.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  {`If those public and private keys match, the balance in your digital wallet will increase, and the senders will decrease accordingly. There is no actual exchange of real physical coins. The transaction is signified simply by a transaction record on the `}
                </span>
              </span>
              <a
                className="text-[inherit]"
                href="https://www.notion.so/7-Blockchain-Intro-8fcb12d2e6e0406b9148a429ae22e73b?pvs=21"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      blockchain
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span>
                  {" "}
                  and a balance change in your cryptocurrency wallet.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[7.94rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Types of Cryptocurrency Wallets?</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <ul className="m-0 text-[1rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Digital wallets for cryptocurrencies have a variety of
                    formats, each with their own pros and cons regarding ease of
                    use for trading and security.
                  </span>
                </span>
              </li>
              <li>
                <span>
                  <span>
                    When using ANY form of digital wallet make sure you
                    safeguard the passwords that enable you access to them,
                    ideally offline.
                  </span>
                </span>
              </li>
            </ul>
          </div>
          <img
            className="relative w-[48.13rem] h-[27.06rem] object-cover"
            alt=""
            src="/i45@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">Hot Storage Software Wallets</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Hot storage wallets (software wallets) are directly connected
                  to the internet. They can be in the form of a mobile phone
                  app, a desktop software program, or an online provider (hence
                  the term “hot” storage). These wallets are free but come with
                  the downside of possible security risks since they are
                  connected to the internet making them susceptible to potential
                  online theft.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  A software wallet is one that is connected to the internet,
                  often accessed via an in-browser extention. These are the most
                  common type of Wallets, such as MetaMask which has over 10
                  million users.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Your information is encrypted and secured by your password and
                  seed phrase (Recovery phrase). Your seed phrase is your
                  12-word master key, store it safely offline, and never share
                  it.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  We expect this is the type of wallet 95% of Secured Members
                  will be using, and we will recommend which wallet to go for
                  further down this page.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  {`Digital wallet providers have been making changes and increasing security in an effort to prevent these cryptocrimes. According to a study by `}
                </span>
              </span>
              <a
                className="text-[inherit]"
                href="https://ciphertrace.com/cryptocurrency-crime-and-anti-money-laundering-report-may-2021/"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      CipherTrace
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span>
                  {" "}
                  (blockchain security firm) cryptocurrency theft dropped 57% in
                  2020.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  It is always good practice to treat your digital wallet
                  similarly to your physical one and ensure the proper security
                  measures are taken to safeguard your assets.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 text-[1.56rem] pl-[2.06rem]">
            <li>
              <span>
                <span>
                  Some examples of the types of hot storage wallets are:
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Desktop Wallets</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Desktop wallets are apps that run on your local PC and store
                  all your cryptocurrency on your desktop computer. The
                  advantage with using a desktop wallet is that you have
                  complete control of your funds. This will eliminate risk that
                  could come from a third party that can lose or freeze your
                  funds. You still will need to ensure your computer is secured
                  and safe from any malware to secure and back up your wallet.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Examples of popular desktop wallets include Atomic Wallet,
                  Bitcoin Core and Electrum Atomic
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Mobile Wallets</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Mobile wallets are apps that run on your smartphone to store
                  and control your crypto funds. These wallets are useful for
                  face-to-face payments and can take advantage of QR codes to
                  allow for fast payments. Similar to desktop wallets, you need
                  to ensure you back up your mobile device to keep your
                  cryptocurrencies safe from loss of device.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Popular mobile wallets examples include Bitcoin Wallet, Green
                  Address and Mycelium
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">Web Wallets</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Web wallets are browser-based wallets that can be used either
                  on desktop or mobile. Their main downside is they don't
                  provide the full control over your assets like the other
                  wallets.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <a
                className="text-[inherit]"
                href="https://www.coinbase.com/join/rackz_6"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      Coinbase
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span>{` (a popular crypto exchange), `}</span>
              </span>
              <a
                className="text-[inherit]"
                href="https://join.robinhood.com/ravis309"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      Robinhood
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span>{` (popular brokerage), `}</span>
              </span>
              <a
                className="text-[inherit]"
                href="https://metamask.io/"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      Metamask
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span>
                  {" "}
                  (popular software crypto wallet used to interact with Ethereum
                  Blockchain) all provide their users with web-based wallets.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Maybe should include comments about MetaMask? And wallets used
                  for staking?
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Hot Wallet Advantages:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Ease of Use - Often connected with exchanges and has simple
                  clean UI
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Always online - eliminates need to transition between offline
                  and online to make a transaction
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Usually free</span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Liquid - easier to do transfer crypto back into exchanges to
                  continue trading
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Hot Wallet Disadvantages:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li>
              <span>
                <span>Potential security risks with it being online</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">Hardware Cold Storage Wallets</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  A cold wallet (hardware wallet) is a specially built portable
                  device used to store your various cryptocurrencies in physical
                  form.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Similar to an actual physical wallet, the main advantage is
                  that you are able to physically carry your cryptos around with
                  you at any time. Their compact design allows for discretion
                  and ease of access when transferring your cryptos.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Cold wallets can cost as much as $100 but because the cash is
                  stored offline — hence the “cold” name — they are considered
                  much more secure than hot wallets.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  A hardware wallet is an offline wallet, you can view it like a
                  safe. By transferring your crypto into your hard wallet, you
                  will officially own the currency, rather than an "I owe you"
                  you have on an exchange (like a bank), and this means that it
                  is essentially impossible to be hacked (unless someone stole
                  it from your house, and they knew your passwords, which is
                  very unlikely).
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  If you own a lot of crypto, you may want to look into a hard
                  wallet to ensure your assets (including your private keys) are
                  as safe as possible.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>The two notable cold wallet providers are:</span>
              </span>
            </li>
            <li>
              <a
                className="text-[inherit]"
                href="https://shop.ledger.com/?r=461ed6de60cc"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">Ledger</span>
                  </span>
                </span>
              </a>
              <span>
                <span>
                  : Designed like a USB stock, Ledger Nano X is an affordable
                  alternative to Trezor.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Cold Wallet Advantages:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li>
              <span>
                <span>
                  Provides much better security because your private keys are
                  stored offline.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Cold Wallet Disadvantages:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Can be expensive- prices can range from US $60 - US $200
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Delayed trading - cryptocurrencies must be sent from cold
                  wallet to an exchange before any trading can occur. With such
                  extreme volatility in the crypto market, this can be the
                  difference in your profit margins.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Slow setup time - Requires at least 10 minutes for initial set
                  up. Device will also need to be plugged in before sending any
                  cryptocurrencies.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Inconvenient - ease of access is limited as opposed to using
                  an app on your mobile phone.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Staking</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  The process of locking up crypto assets in order to obtain
                  incentives or earn interest is known as Crypto Staking.
                  Cryptocurrencies are based upon blockchain technology, which
                  involves the verification of crypto transactions and the
                  storage of that generated data on the blockchain. Validating
                  those transactions on a blockchain is referred to as staking.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  These validation processes are termed "proof-of-stake" or
                  "proof-of-work" depending on the kind of cryptocurrency you're
                  working with and its accompanying technology. Each of these
                  processes assists various crypto networks in reaching
                  consensus, or confirmation that all transaction data is
                  accurate.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Achieving that consensus needs the participation of others.
                  This is where staking comes in! Investors that actively
                  retain, or lock up their crypto holdings in their crypto
                  wallet, are participating in the consensus-taking processes of
                  these networks. These stakers are responsible for approving
                  and validating blockchain transactions.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  The networks then reward these investors for doing so. The
                  specific benefits will vary.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Here are some examples of the benefits for staking your
                  crypto:
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Gaining voting rights</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Easy way to get additional crypto by earning interest on your
                  holdings
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  No physical equipment is needed like with crypto mining
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Environmentally friendly</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Supports the blockchain of the cryptocurrency you are invested
                  in
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  If you are struggling to grasp this concept it may be
                  beneficial to compare crypto staking to placing money in a
                  traditional savings account.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Let's say you put some money in a savings account at a bank
                  and decide to keep it there long term. You, the depositor,
                  obtain yearly interest as a reward from the bank. They utilize
                  the money for other reasons (lending, trading, etc.)
                  Similarly, staking coins is comparable to earning interest for
                  holding money in a bank account.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Should you stake your crypto assets? Here are some risks to
                  keep in mind when deciding whether or not to do so:
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Volatility - sudden market changes can effect the valuation of
                  your POS crypto and this can lead to illiquidity by having it
                  locked up in staking and unable to sell.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Bad validator - when you stake a coin by delegating to a
                  validator and they refuse to pay
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Account/Wallet Breaches - Staking wallet/exchange gets hacked
                </span>
              </span>
            </li>
          </ul>
        </div>
        <img
          className="relative w-[89.75rem] h-[40.33rem] object-cover"
          alt=""
          src="/i46@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">Exchanges</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Binance</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  One of the best place to use for staking your crypto assets
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Offers a service called "Locked Staking"</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  This is where you stake your crypto assets for an agreed
                  amount of time to support the selected blockchain.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Once period is complete, you will receive your coins back with
                  interest ranging from 3%-35% APY.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <a
                className="text-[inherit]"
                href="https://www.coinbase.com/staking"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      Coinbase
                    </span>
                  </span>
                </span>
              </a>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Range of coins available to stake is currently low but
                  increasingly steadily
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Cozmos, Tezos and Algorand</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Pledges to cover users balances lost by any `}</span>
              </span>
              <a
                className="text-[inherit]"
                href="https://www.notion.so/dd0fe24113e24cada56d07a874dfde35?pvs=21"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      slashing events
                    </span>
                  </span>
                </span>
              </a>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Move funds you want to stake (granted its stake-able) in their
                  "Vault"
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Some coins will require lockup for a certain period</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <a
                className="text-[inherit]"
                href="https://www.stakingrewards.com/savings/kucoin/"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">Kucoin</span>
                  </span>
                </span>
              </a>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Created a platform solely for staking - "Pool-X"</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Features many different staking types</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  "Soft Staking" program - allows users to stake a large range
                  of over 32 cryptocurrencies
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Flexible and withdrawable at any time</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Issues up to 15% of staking rewards</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  "Pool-X" offers "Locked Staking" which boasts over 100% APY
                  for some smaller cryptocurrencies.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Provides some of the highest staking rewards available
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>Lockup periods can range from a few days to months</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Wallets</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <a
                className="text-[inherit]"
                href="https://www.exodus.com/earn-crypto/"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">Exodus</span>
                  </span>
                </span>
              </a>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Well know soft (hot) wallets in the market</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Wallet supports over 100 different assets</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  7 various cryptocurrencies available for staking ranging from
                  Cardano to Vechain
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Can be done via their rewards app</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <a
                className="text-[inherit]"
                href="https://support.atomicwallet.io/article/140-staking-options-in-atomic-wallet"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      Atomic Wallet
                    </span>
                  </span>
                </span>
              </a>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Has an online staking rewards calculator to help you estimate
                  potential earnings
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Supports 14 various cryptocurrencies for staking with APY
                  rates up to 18% on high cap coins
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Continually adding supported crypto for staking</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Staking is flexible allowing for withdrawals at your
                  discretion
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <a
                className="text-[inherit]"
                href="https://www.ledger.com/staking"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">Ledger</span>
                  </span>
                </span>
              </a>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Popular hardware (cold) wallet</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Supports over 26 various cryptocurrencies</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  7 of which are available to stake - earnings rewards straight
                  into your wallet
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Variety of staking services each with their own capabilities
                  and rewards
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Takeaways:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Most exchanges allow you to purchase cryptocurrency right
                  after signing up, and they are already held in a wallet on the
                  exchange. Thus, finding an additional wallet is not necessary.
                  However, moving to a hot wallet or more-secure cold storage
                  can offer more security especially if you have a large number
                  of cryptocurrency funds.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Overall most market experts agree it’s okay to leave a
                  relatively small amount of your crypto on a mainstream
                  exchange like Coinbase.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  For cryptocurrency traders who have a lot of cryptocurrency
                  assets, a combination of hot wallets for quick trading or
                  purchases and cold wallets to secure the bulk of their
                  cryptocurrency resources is recommended.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  It is always good practice to treat your digital wallet
                  similarly to your physical wallet and ensure the proper
                  security measures are taken to safeguard your assets.
                </span>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300"
        href="/lesson11">
        <div className="w-full">
          <b className="inline-block flex-1 w-full relative text-center pb-[0.8rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson10;
